import React, { forwardRef } from 'react';

import { OVERFLOW_REST_ID } from '../Overflow.utils';

import { type OverflowItemProps, OverflowItem } from './OverflowItem';

type OverflowRestProps = Omit<OverflowItemProps, 'id'>;

export const OverflowRest = forwardRef<HTMLElement, OverflowRestProps>(
    ({ children, ...props }, ref) => {
        return (
            <OverflowItem ref={ref} {...props} id={OVERFLOW_REST_ID}>
                {children}
            </OverflowItem>
        );
    }
);
OverflowRest.displayName = 'OverflowRest';
